import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/useAuth";

export default function OAuthHandler() {
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const userParam = params.get("user");

    if (!token || !userParam) {
      navigate("/login", { replace: true });
      return;
    }

    const user = JSON.parse(decodeURIComponent(userParam));
    login(token, user);
    navigate("/dashboard", { replace: true });
  }, []);

  return null;
}
